import { Drawer, Grid } from "antd";
import { EntityForm } from "./EntityForm";

type Row = Record<string, unknown> & { id: string };

interface Props {
  entity: string;
  title: string;
  /** Values the new row starts with: the search text as its name, the parent of a dependent reference. */
  prefill: Record<string, string>;
  /** Level of this drawer: the first «+» opens level 1, a «+» inside it level 2; deeper is refused (section 7.4). */
  depth: number;
  onClose: () => void;
  onCreated: (row: Row) => void;
}

/**
 * UI-15 / section 7 of the UX spec: the short full form of a catalogue entry, opened by «+» inside a reference list
 * over the current card. The same meta-driven form as the entity's own page (required fields, validation, hooks);
 * on save the created row goes back to the field. A separate <form> in a portal: Enter inside never submits the
 * parent card, and cancelling leaves the parent's choice as it was.
 */
export function CreateDrawer({ entity, title, prefill, depth, onClose, onCreated }: Props) {
  const screens = Grid.useBreakpoint();
  return (
    <Drawer
      open
      title={title}
      width={screens.md ? Math.min(760, window.innerWidth - 48 * depth) : "100%"}
      onClose={onClose}
      destroyOnHidden
      maskClosable={false}
      keyboard
      zIndex={1010 + depth}
      data-testid={`create-drawer-${entity}`}
    >
      <EntityForm entity={entity} id="new" prefill={prefill} embedded depth={depth} onSaved={onCreated} onCancel={onClose} />
    </Drawer>
  );
}
